import {Box} from '@mui/material';
import styles from './AppLogo.module.scss';

export default function ApLoadingLogo () {
    return (<Box className={styles.circleLogoBackground}>
        <img className={styles.circleLogoBackground} alt='Logotipo CenteCaribe' src={`${process.env.PUBLIC_URL}/img/logo_circle.png`}/>
    </Box>);
}